import styled from 'styled-components';

export const BulletListItemWrapper = styled.div`
	display: flex;
`;

export const BulletListItemContent = styled.div`
	// Minus icon width to prevent icon from being squeezed.
	width: calc(100% - 24px);
	margin-left: 4px;
`;

export const Title = styled.div`
	margin-bottom: 10px;
	color: #101010;
	font-size: 18px;
`;

export const Description = styled.div`
	font-weight: 300;
	white-space: pre-wrap;
`;

export const GridContent = styled.div`
	display: grid;
	grid-template-columns: repeat(1, 1fr);
	grid-column-gap: 40px;
	grid-row-gap: 32px;

	@media ${props => props.theme.device.smTablet} {
		grid-template-columns: repeat(1, 1fr);
		grid-column-gap: 0px;
		grid-row-gap: 20px;
	}

	@media ${props => props.theme.device.mobile} {
		grid-template-columns: repeat(1, 1fr);
		grid-column-gap: 0px;
		grid-row-gap: 20px;
	}
`;
